import React from 'react';
import { FileText, HardHat } from 'lucide-react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { CreatableSelect } from '../ui/CreatableSelect';
import { SearchableSelect } from '../ui/SearchableSelect';
import { mockData } from '../../services/mockData';
import { useWorkerOptions } from '../../hooks/useWorkerOptions';
import { sedi } from '../../data/sedi';
import { WorkerAnagrafica } from '../../types/worker';
interface WorkerAnagraficaFormProps {
  value: Partial<WorkerAnagrafica>;
  onChange: (changes: Partial<WorkerAnagrafica>) => void;
  nameError?: string;
  showCompany?: boolean;
  companyError?: string;
}
export function WorkerAnagraficaForm({
  value,
  onChange,
  nameError,
  showCompany = false,
  companyError
}: WorkerAnagraficaFormProps) {
  const {
    options,
    addOption
  } = useWorkerOptions();
  const companyOptions = mockData.getClients().map(c => ({
    value: c.name,
    label: c.name
  }));
  return <div className="space-y-8" data-id="element-2153" data-mp="3epgyoapf19js">
      <section data-id="element-2154" data-mp="18gadslhonnfh">
        <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-2155" data-mp="18hv7ya0354ct">
          <HardHat className="h-4 w-4" data-id="element-2156" data-mp="13j0hclvvmbi5" /> Dati personali
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2157" data-mp="1h9nfabttbxd6">
          <div className="col-span-full" data-id="element-2158" data-mp="1hayhw8biuz2p">
            <Input label="Nome e cognome" placeholder="Mario Rossi" value={value.name || ''} onChange={e => onChange({
            name: e.target.value
          })} error={nameError} required data-id="element-2159" data-mp="1ci5999cxn6lc" />
          </div>
          <Input label="Data di nascita" type="date" value={value.birthDate || ''} onChange={e => onChange({
          birthDate: e.target.value
        })} data-id="element-2160" data-mp="208hrbd1w6jpn" />
          <Input label="Città di nascita" placeholder="Es. Arezzo" value={value.birthPlace || ''} onChange={e => onChange({
          birthPlace: e.target.value
        })} data-id="element-2161" data-mp="5tf7nvzixvun" />
          <Input label="Provincia di nascita" placeholder="Es. AR, FI, RM..." value={value.birthProvince || ''} onChange={e => onChange({
          birthProvince: e.target.value
        })} data-id="element-2162" data-mp="20y6gwgilipgo" />
          <Input label="Nazionalità" placeholder="Es. Italiana" value={value.nationality || ''} onChange={e => onChange({
          nationality: e.target.value
        })} data-id="element-2163" data-mp="2atzu82452mzi" />
          <Input label="Codice Fiscale" placeholder="RSSMRA..." value={value.fiscalCode || ''} onChange={e => onChange({
          fiscalCode: e.target.value.toUpperCase()
        })} data-id="element-2164" data-mp="2ju4xc02auz7v" />
          <Input label="Email personale" type="email" placeholder="mario.rossi@email.it" value={value.email || ''} onChange={e => onChange({
          email: e.target.value
        })} data-id="element-2165" data-mp="2yjkceisgxg7q" />
        </div>
      </section>

      <div className="h-px bg-slate-100" data-id="element-2166" data-mp="vyq33tjjg8rq"></div>

      <section data-id="element-2167" data-mp="vzjcl29vtcdk">
        <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-2168" data-mp="vvvia0wm4lxs">
          <FileText className="h-4 w-4" data-id="element-2169" data-mp="mxijmhlolchp" /> Rapporto di lavoro
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2170" data-mp="mzmium8mxnbn">
          {showCompany && <div className="col-span-full" data-id="element-2171" data-mp="i09we2loei9l">
              <SearchableSelect label="Azienda" value={value.company || ''} onChange={e => onChange({
            company: e.target.value
          })} options={companyOptions} placeholder="Cerca e seleziona un'azienda..." error={companyError} required data-id="element-2172" data-mp="1fmpff8tr3nz9" />
            </div>}
          <CreatableSelect label="Tipo di rapporto" value={value.employmentType || ''} onChange={v => onChange({
          employmentType: v
        })} options={options.employmentType} onCreate={v => addOption('employmentType', v)} newPlaceholder="Inserisci nuovo tipo di rapporto" data-id="element-2173" data-mp="1ycf8nrhv81p2" />
          <CreatableSelect label="Tipo di contratto" value={value.contractType || ''} onChange={v => onChange({
          contractType: v
        })} options={options.contractType} onCreate={v => addOption('contractType', v)} newPlaceholder="Inserisci nuovo tipo di contratto" data-id="element-2174" data-mp="1i73xi3tif9m9" />
          <CreatableSelect label="Mansione" value={value.role || ''} onChange={v => onChange({
          role: v
        })} options={options.mansione} onCreate={v => addOption('mansione', v)} newPlaceholder="Inserisci nuova mansione" data-id="element-2175" data-mp="21ta01uxtbohk" />
          <CreatableSelect label="Reparto di lavoro" value={value.department || ''} onChange={v => onChange({
          department: v
        })} options={options.reparto} onCreate={v => addOption('reparto', v)} newPlaceholder="Inserisci nuovo reparto" data-id="element-2176" data-mp="2fsswvrl6bdek" />
          <Select label="Sede" value={value.sede || ''} onChange={e => onChange({
          sede: e.target.value
        })} options={[{
          value: '',
          label: 'Seleziona sede...'
        }, ...sedi.map(s => ({
          value: s,
          label: s
        }))]} data-id="element-2177" data-mp="44whm7ngv9ic" />
          <CreatableSelect label="Ruolo" value={value.ruolo || ''} onChange={v => onChange({
          ruolo: v
        })} options={options.ruolo} onCreate={v => addOption('ruolo', v)} newPlaceholder="Inserisci nuovo ruolo" data-id="element-2178" data-mp="3mcdjc5nrh5sf" />
        </div>
      </section>
    </div>;
}